import { FloatingPanel, Tooltip } from '@hue/design-system';
import { ChevronDown, ChevronRight, Route } from 'lucide-react';
import { useRef, useState } from 'react';
import { useGuides } from './guide-context.js';

/// Roteiros fica fixo perto do fim do menu, acima de quem está logado: não rola junto com os
/// módulos e está à mão em qualquer tela (ADR 0084).
export function GuideMenu({
  compact = false,
  onOpened,
}: {
  compact?: boolean;
  onOpened?: () => void;
}) {
  const { available, open } = useGuides();
  const [expanded, setExpanded] = useState(true);
  const [flyout, setFlyout] = useState(false);
  const anchor = useRef<HTMLButtonElement>(null);
  if (available.length === 0) return null;
  const entries = available.map((guide) => (
    <button
      key={guide.key}
      type="button"
      onClick={() => {
        setFlyout(false);
        open(guide);
        onOpened?.();
      }}
      className="flex min-h-10 w-full items-center rounded-xl px-3 py-2 text-left text-sm text-content-muted transition hover:bg-content/5 hover:text-content focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500/50"
    >
      {guide.title}
    </button>
  ));
  if (compact) {
    return (
      <div className="shrink-0 border-t border-surface-border p-2">
        <Tooltip content="Roteiros" side="right">
          <button
            ref={anchor}
            type="button"
            aria-label="Roteiros"
            aria-haspopup="menu"
            aria-expanded={flyout}
            onClick={() => setFlyout(!flyout)}
            className="grid h-11 w-full place-items-center rounded-xl text-content-muted transition hover:bg-content/5 hover:text-content focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500/50"
          >
            <Route className="size-5" aria-hidden="true" />
          </button>
        </Tooltip>
        {flyout ? (
          <FloatingPanel
            anchorRef={anchor}
            onDismiss={() => setFlyout(false)}
            role="menu"
            aria-label="Roteiros"
            className="w-60 space-y-1 rounded-2xl border border-surface-border bg-surface-card p-2"
          >
            <p className="px-3 pb-1 pt-1 text-[11px] font-semibold uppercase tracking-[.08em] text-content-muted">
              Roteiros
            </p>
            {entries}
          </FloatingPanel>
        ) : null}
      </div>
    );
  }
  const Chevron = expanded ? ChevronDown : ChevronRight;
  return (
    <div className="shrink-0 border-t border-surface-border px-2 py-2">
      <button
        type="button"
        aria-expanded={expanded}
        onClick={() => setExpanded(!expanded)}
        className="flex min-h-10 w-full items-center gap-3 rounded-xl px-3 py-2 text-sm font-medium text-content-muted transition hover:bg-content/5 hover:text-content focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500/50"
      >
        <Route className="size-5 shrink-0" aria-hidden="true" />
        <span className="flex-1 text-left">Roteiros</span>
        <Chevron className="size-4" aria-hidden="true" />
      </button>
      {expanded ? (
        <div className="ml-5 mt-1 grid gap-1 border-l border-surface-border pl-2">{entries}</div>
      ) : null}
    </div>
  );
}
